import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {PosuserSearchModel} from "../posuser-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-posuser-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(PosuserSingleSelectEditControlComponent),
        provideSearchModel(PosuserSearchModel)
    ]
})
export class PosuserSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<PosuserSearchModel> {
    constructor(model: PosuserSearchModel, injector: Injector) {
        super(model, injector, "userId", "fullName");

    }
}
